module.exports = __webpack_public_path__ + "img/yg.303a46a6.png";